import React from 'react';
import PropTypes from 'prop-types';
import clsx from '@strava/ui/clsx';
import StravaLogo from '@strava/ui/StravaLogo';
import {
  AccountAuthButton,
  FACEBOOK,
  GOOGLE,
  EMAIL,
  DisclaimerText,
  elemAttrForAnalytics
} from '@strava/authentication-ui';
import { getProfileVisibility } from '../../helpers/getProfileVisibility';
import { useLoggedOutAthletePageContext } from '../../state/LoggedOutAthletePageContext';

import styles from './AuthenticationPanel.module.scss';

const AuthenticationPanel = ({ className }) => {
  const { state, t, track } = useLoggedOutAthletePageContext();
  const { athleteData } = state;
  const { athlete, authorizationUrls } = athleteData;

  const handleExtAuthBtnClick = (option) => {
    const element = elemAttrForAnalytics(option);

    track({
      action: 'click',
      element,
      properties: {
        profile_visibility: getProfileVisibility(athlete)
      }
    });

    window.location = authorizationUrls[option];
  };

  const handleEmailAuthBtnClick = () => {
    track({
      action: 'click',
      element: 'start_signup',
      properties: {
        profile_visibility: getProfileVisibility(athlete),
        signup_copy: 'use_my_email'
      }
    });

    window.location = authorizationUrls[EMAIL];
  };

  return (
    <div className={clsx(styles.authenticationPanel, className)}>
      <div className={styles.login}>
        {t('already_a_member')}{' '}
        <a
          href="/login"
          onClick={() =>
            track({
              action: 'click',
              element: 'already_member_login',
              properties: {
                profile_visibility: getProfileVisibility(athlete)
              }
            })
          }
        >
          {t('log_in')}
        </a>
      </div>

      <div className={styles.branding}>
        <StravaLogo alt="Strava" width={117} height={24} />
      </div>

      <h2 className={styles.joinAthlete}>
        {t('join_athlete', { athlete_name: athlete.firstname })}
      </h2>

      <AccountAuthButton
        variant="facebook"
        onClick={() => handleExtAuthBtnClick(FACEBOOK)}
        data-testid="facebook_auth_btn"
      >
        {t('cta_facebook')}
      </AccountAuthButton>
      <AccountAuthButton
        variant="google"
        onClick={() => handleExtAuthBtnClick(GOOGLE)}
        data-testid="google_auth_btn"
      >
        {t('cta_google')}
      </AccountAuthButton>
      <AccountAuthButton
        variant="email"
        onClick={() => handleEmailAuthBtnClick()}
        data-testid="email_auth_btn"
      >
        {t('cta_email')}
      </AccountAuthButton>
      <DisclaimerText />
    </div>
  );
};

AuthenticationPanel.defaultProps = {
  className: null
};

AuthenticationPanel.propTypes = {
  className: PropTypes.string
};

export default AuthenticationPanel;
